module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "aria-labelledby": "foreword_hd",
      "role": "doc-foreword"
    }
  }, [_c('h1', {
    staticClass: "h1a",
    attrs: {
      "id": "foreword_hd"
    }
  }, [_c('span', {
    attrs: {
      "aria-label": "page 4",
      "id": "page_4",
      "role": "doc-pagebreak"
    }
  }, [_c('span', {
    attrs: {
      "aria-label": "page 5",
      "id": "page_5",
      "role": "doc-pagebreak"
    }
  }, [_c('span', {
    attrs: {
      "aria-label": "page 6",
      "id": "page_6",
      "role": "doc-pagebreak"
    }
  }, [_c('span', {
    attrs: {
      "aria-label": "page 7",
      "id": "page_7",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("FOREWORD")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("I have known Susan Wong for ten years and in that time, I have come to appreciate the depth of knowledge and dedication she brings to her chosen area of expertise: “the art and science of pooping.” In the care of her patients, Susan is masterful in her analysis of complex clinical issues related to bowel function, and competent and kind in management of these problems.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("In this book, she has compiled forty years of accumulated knowledge and wisdom into a volume that is practical and humorous. It incorporates concrete examples and facts. The general public will enjoy it and anyone with pooping problems will find it pragmatic and comprehensive.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("For as long as I have known her, Susan’s goal has been “to help people poop better.” This book is a reflection of that and is a must read for anyone with interest in this topic.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentn"
  }, [_vm._v("Ankit Sarin, MD")]), _vm._v(" "), _c('p', {
    staticClass: "noindentn"
  }, [_vm._v("Associate Professor")]), _vm._v(" "), _c('p', {
    staticClass: "noindentn"
  }, [_vm._v("Colon and Rectal Surgery")]), _vm._v(" "), _c('p', {
    staticClass: "noindentn"
  }, [_vm._v("University of California–San Francisco")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-316292f3","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/e9781646042845/xhtml/foreword.vue
// module id = 66
// module chunks = 0